import { Vertical } from '../models/configuration';

export function mapTextValuesToEnum<T extends string>(
  text: string,
  enumObj: Record<string, T>,
): T[] {
  if (!text) return [];

  return text
    .split(',')
    .map((value) => value.trim())
    .filter((value): value is T => Object.values(enumObj).includes(value as T));
}

export function mapDatabaseVerticalToEnum(
  textValue: string | null | undefined,
): Vertical {
  if (!textValue) return Vertical.Base;
  const normalized = textValue.toLowerCase();

  if (normalized === 'wm') {
    return Vertical.WM;
  } else {
    return Vertical.Base;
  }
}
